<template>
  <div class="w12">
    <asset-header></asset-header>
    <div class="w12 deposit-coin-page">
      <div
        v-if="
          userInfo.foreignYn == 'Y' &&
            (!userInfo.dueDiligenceInfo || !userInfo.dueDiligenceInfo.corpCode)
        "
        class="deposit-box"
      >
        {{ $t("deposit.onlyKoreanCanUseDepositService") }}
      </div>
      <div v-else-if="coin.ioInEnable == 'N'" class="obstruct-wrap">
        <div class="title">
          {{
            $t("withdraw.obstruct.deposit", [
              coin.code == "KRW" ? $t("원화") : coin.code,
            ])
          }}
        </div>
        <div class="text-box">
          <p>{{ $t("withdraw.obstructNoti.deposit[0]") }}</p>
          <p>{{ $t("withdraw.obstructNoti.deposit[1]") }}</p>
        </div>
      </div>
      <!-- <div v-else-if="!isLoading" class="w12 deposit-box p12"> -->
      <div v-else class="w12 deposit-box">
        <div
          class="deposit-address mb10 bold"
          :class="{ borderBottom: coin.code !== 'USDT' }"
        >
          <!-- {{ coin.code }}  -->
          {{ $t("mypage.depositCoin.입금주소") }}
        </div>
        <template v-if="isWalletNone">
          <!-- 주소 생성 -->
          <div class="w12" flex fjc>
            <button
              class="create-address w12 mt20"
              @click="submitCreatePopup('')"
            >
              {{ $t("mypage.depositCoin.주소 생성") }}
            </button>
          </div>
        </template>
        <template v-else>
          <template v-if="coin.subCoins">
            <div class="deposit-title mt10" flex>
              <div
                class="w6 tab"
                v-for="(subCoin, index) in coin.subCoins"
                :key="`${subCoin.title}-${index}`"
                :class="{ selected: subCoin.active }"
                @click="clickSubCoins(subCoin.title, index)"
              >
                {{ subCoin.title }}
              </div>
            </div>
            <template v-for="(subCoin, index) in coin.subCoins">
              <div
                v-if="subCoin.active"
                :key="`${subCoin.title}-${index}`"
                class="w12"
              >
                <template v-if="subCoin.getWallet">
                  <div class="text-box">
                    <p v-if="coin.code !== 'NFTS'" class="noti1">
                      {{ $t("mypage.depositCoin.checkVirtualAsset") }}
                    </p>
                    <p
                      class="noti2"
                      v-html="coinTypeDescription(subCoin.title)"
                    ></p>
                  </div>
                  <div class="w12 input-box mb20">
                    <input type="text" :value="subCoin.address" readonly />
                    <i
                      class="el-icon-document-copy copy"
                      @click="copyAddrConfirmed()"
                    />
                  </div>
                  <div class="w12" v-if="coin.tagYn === 'Y'">
                    <div class="memo-name">
                      {{ $t("mypage.depositCoin.입금메모") }}
                    </div>
                    <div class="w12 input-box">
                      <input type="text" :value="subCoin.tag" readonly />
                      <i
                        class="el-icon-document-copy copy"
                        @click="copyAddrMemo()"
                      />
                    </div>
                  </div>

                  <div class="w12 qr-content" flex fdc fic>
                    <div class="qr-box">
                      <div class="qr" v-html="subCoin.qr"></div>
                    </div>
                    <div class="w12 button-box">
                      <router-link
                        :to="`/balances/log/${coin.code}`"
                        tag="button"
                        class="w12"
                        >{{
                          $t("mypage.depositCoin.입금내역보기")
                        }}</router-link
                      >
                    </div>
                  </div>
                </template>
                <div
                  v-else
                  :key="`${subCoin.title}-${index}`"
                  class="w12 mt20"
                  flex
                  fjc
                >
                  <button
                    class="create-address w12 mt20"
                    @click="submitCreatePopup(subCoin.title)"
                  >
                    {{ $t("mypage.depositCoin.주소 생성") }}
                  </button>
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="w12">
              <div class="w12 input-box mb20">
                <input type="text" :value="coin.address" readonly />
                <i
                  class="el-icon-document-copy copy"
                  @click="copyAddrConfirmed()"
                />
              </div>
              <div class="w12" v-if="coin.tagYn === 'Y'">
                <div class="memo-name">
                  {{ $t("mypage.depositCoin.입금메모") }}
                </div>
                <div class="w12 input-box">
                  <input type="text" :value="coin.tag" readonly />
                  <i
                    class="el-icon-document-copy copy"
                    @click="copyAddrMemo()"
                  />
                </div>
              </div>

              <div class="w12 qr-content" flex fdc fic>
                <div class="qr-box">
                  <div class="qr" v-html="coin.qr"></div>
                </div>
                <div class="w12 button-box">
                  <router-link
                    :to="`/balances/log/${coin.code}`"
                    tag="button"
                    class="w12"
                    >{{ $t("mypage.depositCoin.입금내역보기") }}</router-link
                  >
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
      <div class="noti-box mt30">
        <div class="title" flex fic>
          <img src="../../../assets/img/icon/ico_exclamation.png" />
          <span class="fs14 fw500"> {{ noticeTitle }} </span>
        </div>
        <div v-html="noticeDesc" class="desc mt10 fs14"></div>
        <!-- <ul class="w12">
          <li>
            <span class="fs12">{{
              $t("mypage.depositCoin.주의사항.내용[0]")
            }}</span>
          </li>
          <li>
            <span class="fs12">{{
              $t("mypage.depositCoin.주의사항.내용[1]")
            }}</span>
          </li>
          <li>
            <span class="fs12">{{
              $t("mypage.depositCoin.주의사항.내용[2]")
            }}</span>
          </li>
          <li>
            <span class="fs12">{{
              $t("mypage.depositCoin.주의사항.내용[3]")
            }}</span>
          </li>
        </ul> -->
      </div>
    </div>

    <!-- 본인인증 필요 안내 -->
    <el-dialog
      :title="$t('selfCertification.title')"
      :visible.sync="needVerification"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="modal-type01 popup"
      center
    >
      <div class="text-center">
        <p
          class="text-type01 mgb25"
          v-html="$t('selfCertification.completeAuthenticationProcess')"
        ></p>
      </div>
      <div slot="footer" class="dialog-footer" flec fjc>
        <router-link
          tag="button"
          to="/"
          class="btn-style01"
          @click.native="needVerification = false"
        >
          {{ $t("confirm.cancel") }}
        </router-link>
        <router-link
          tag="button"
          :to="{ name: 'confirm' }"
          @click.native="needVerification = false"
        >
          {{ $t("confirm.ok") }}
        </router-link>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Clipboard from "copy-to-clipboard";
import * as QRGenerator from "qr-image";
import { address } from "bitcoinjs-lib";
import * as coinData from "@/util/coinData";

import Api from "@/common/Api";
import { parseAndConvertCashAddress } from "@/common/BchParser";
import AssetHeader from "../component/asset/header";

import axios from "axios";
import { authIDModal } from "@/common/authIdModal";

const isLiveServer =
  window.location.hostname === "m.flybit.com" ||
  window.location.hostname === "m.v1.flybit.com";

const instance = axios.create({
  baseURL: isLiveServer
    ? "https://third.flybit.com"
    : "https://third.dev.flybit.com",
  timeout: 1000,
});

if (process.env.NODE_ENV === "development") {
  window.p = parseAndConvertCashAddress;
}

// 라이트코인 주소 변환
function convertLTCAddr(address) {
  try {
    const decoded = address.fromBase58Check(address);
    let version = decoded["version"];
    let message = "";

    switch (version) {
      case 5:
        message = "Mainnet p2sh address: ";
        version = 50;
        break;
      case 50:
        message = "Mainnet p2sh address (deprecated): ";
        version = 5;
        break;
      case 196:
        message = "Testnet p2sh address: ";
        version = 58;
        break;
      case 58:
        message = "Testnet p2sh address (deprecated): ";
        version = 196;
        break;
      default:
        throw "unknown";
    }
    // 5 <-> 50
    // 196 <-> 58
    address = address.toBase58Check(decoded["hash"], version);
  } catch (err) {
    message = "Please enter a valid address.";
    address = "";
  }

  return address;
}

export default {
  components: {
    AssetHeader,
  },
  created() {
    this.useNoticeApi();
  },
  data() {
    return {
      coin: {},
      isWalletNone: false,
      isLoading: true,
      needVerification: false,
      authLevelLimit: 2,
      noticeTitle: "",
      noticeDesc: "",
    };
  },
  computed: {
    ...mapState(["Server"]),
    ...mapGetters(["coinSettings", "authLevel", "userInfo"]),
  },
  async mounted() {
    authIDModal(this.userInfo);

    if (this.coinSettings[this.$route.params.coin]) {
      // 코인 SETTING
      await this.setCoin();

      // 지갑 여부 판단해서 지갑세팅
      await this.setWallets();

      // 로딩완료
      this.isLoading = false;
    }
  },
  methods: {
    async setCoin() {
      // 딥카피
      this.coin = _.cloneDeep(this.coinSettings[this.$route.params.coin]);
    },

    async setWallets() {
      try {
        const { data } = await Api.User.getWalletDetail(this.coin.id);
        // 탭 active 값 넣어주기
        if (this.coin.subCoins) {
          // this.coin.subCoins.length = 2; // bsc 코인 가림용 임시 코드
          this.coin.subCoins.forEach((subCoin, index) => {
            subCoin.getWallet = false;
            subCoin.active = false;

            if (index === 0) {
              subCoin.active = true;
            }

            if (!data.result.address) {
              this.isWalletNone = true;
              return;
            } else {
              if (data.result.address && subCoin.title === "ERC-20") {
                subCoin.getWallet = true;
              } else if (
                data.result.walletSubList &&
                subCoin.title === "TRC-20"
              ) {
                subCoin.getWallet = true;
              }
            }
          });
        }
        // 주소 세팅 후 에러없으면 return
        this.addressSetting(data.result);
        return;
      } catch (error) {
        console.log(error);
      }
      // 에러로 떨어져서 여기까지오면 지갑이 없는 경우임
      // 나중에 백앤드랑 확인해서 더 좋은 방법으로 error처리 해야함
      this.isWalletNone = true;
    },

    async submitCreatePopup(type = "") {
      await this.createAddress(type);
    },

    async createAddress(type) {
      let token = "";

      /**
       * subCoins가 지금은 ERC / TRC두개라 생각하고 작업해놓음
       * 2개 이상일 경우 여기 수정해야함
       * TRC / ERC 토큰 있어야 API 오류안남
       **/
      if (type !== "" || this.coin.subCoins) {
        type === "TRC-20" ? (token = "TRX") : (token = "ETH");
      }
      const params = {
        seToken: token,
      };

      try {
        const { data } = await Api.User.createWallet(this.coin.id, params);

        this.addressSetting(data.result);
        location.reload();
      } catch (error) {
        console.log(error);
        location.reload();
      }
    },

    copyAddrConfirmed() {
      if (this.coin.subCoins) {
        this.coin.subCoins.forEach((coin) => {
          if (coin.active) {
            Clipboard(coin.address);

            this.$vs.notify({
              title: this.$t("notice.title.copied"),
              text: this.$t(`notice.content.depositAddressCopied`, [
                this.coin.name,
                coin.title,
              ]),
              type: "warning",
              customClass: "FLYBIT-noti",
              position: "top-left",
            });
          }
        });
      } else {
        Clipboard(this.coin.address);

        this.$vs.notify({
          title: this.$t("notice.title.copied"),
          text: this.$t(`notice.content.addressCopied`, [this.coin.name]),
          type: "warning",
          customClass: "FLYBIT-noti",
          position: "top-left",
        });
      }
    },

    copyAddrMemo() {
      Clipboard(this.coin.tag);

      this.$vs.notify({
        title: this.$t("notice.title.copied"),
        text: `${this.coin.name} 입금 메모가 복사되었습니다.`,
        type: "warning",
        customClass: "FLYBIT-noti",
        position: "top-left",
      });
    },

    addressSetting(response) {
      let { address, tag, walletSubList } = response;

      switch ((this.coin.code || "").toUpperCase()) {
        case "BCH":
          // 비트코인 캐시 주소 parse
          try {
            address = parseAndConvertCashAddress(address);
          } catch (e) {}
          break;
        case "LTC":
          // 라이트코인 캐시 주소 parse
          try {
            address = convertLTCAddr(address);
          } catch (e) {}
          break;
      }

      if (this.coin.subCoins) {
        const newSubCoins = _.cloneDeep(this.coin.subCoins);

        // subCoins가 지금은 ERC / TRC두개라 생각하고 작업해놓음
        // 2개 이상일 경우 여기 수정해야함
        newSubCoins.map((subCoin) => {
          if (subCoin.title === "ERC-20" && subCoin.getWallet) {
            // ERC-20
            subCoin.address = address;
            subCoin.tag = tag;
            subCoin.qr = QRGenerator.imageSync(address, { type: "svg" });
          } else if (subCoin.title === "TRC-20" && subCoin.getWallet) {
            // TRC-20
            subCoin.address = walletSubList[0].wAddr;
            subCoin.tag = walletSubList[0].wDestTag;
            subCoin.qr = QRGenerator.imageSync(walletSubList[0].wAddr, {
              type: "svg",
            });
          }
        });
        this.coin.subCoins = newSubCoins;
      } else {
        // 기본 페이지
        const qr = QRGenerator.imageSync(address, { type: "svg" });

        this.coin = {
          ...this.coin,
          address,
          tag,
          qr,
          walletSubList,
        };
      }
    },
    clickSubCoins(type, index) {
      // 딥카피
      const newSubCoins = _.cloneDeep(this.coin.subCoins);

      // 탭버튼 active 여부
      newSubCoins.forEach((subCoin, coinIndex) => {
        subCoin.active = false;
        if (subCoin.title === type && index === coinIndex) {
          subCoin.active = true;
        }
      });
      this.coin.subCoins = newSubCoins;
    },

    coinTypeDescription(type) {
      if (this.coin.code === "NFTS") {
        return this.$t(`mypage.depositCoin.walletAddress['${this.coin.code}']`);
      }
      return this.$t(`mypage.depositCoin.walletAddress['${type}']`);
    },
    async useNoticeApi() {
      const { data } = await instance.get(`/termof/doDeposit`);
      // console.log("res", data.result.contents.terms[0]);
      const notice = data.result.contents.terms[0];
      this.noticeTitle = notice.title;
      this.noticeDesc = notice.content;
    },
  },
};
</script>

<style scoped lang="scss" src="./depositCoin.scss"></style>
